import { render } from "./RolesTable.vue?vue&type=template&id=5ea1f15a&scoped=true"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"

import "./RolesTable.vue?vue&type=style&index=0&id=5ea1f15a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea1f15a"]])

export default __exports__